import request from '@/utils/request';

const PATH = '/reservation-item/day';

export const getReservationItemDayInfo = (itemUid: string, params: any) => request({
  url: `${PATH}/${itemUid}`,
  method: 'get',
  params,
});
